import React from 'react'
import Lang from "@components/Lang/Lang"
import dayjs from "dayjs";
import HoverIcon from "@components/HoverIcon";
import { Link } from "react-router-dom"
import { Table, Input, Button, Space, Spin, Popover, Modal, Steps,} from 'antd'

import {getShipOrderList} from '../../api/shipmentOrder'

import './index.less'
const { Column, ColumnGroup } = Table
const { Search } = Input
const { Step } = Steps;
class ShipmentOrder extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            filter: {
                orderByPreArrivalPortDate: null,
                orderByLoadDate: '1',
                keyWord: '',
            },
            list: [],
            pagination: {
                pageSize: 50,
                total: 0,
                pageNum: 1,
            },
            showModalLogistics: false,
            logisticsData: [],
        }
    }

    componentDidMount() {
        this.getList()
    }

    /*获取数据*/
    getList() {
        this.setState({
            loading: true
        }, () => {
            getShipOrderList({
                ...this.state.filter,
                pagingQuery: {
                    pageIndex: this.state.pagination.pageNum,
                    pageSize: this.state.pagination.pageSize,
                },
            }).then(res => {
                // console.log(res.data);
                res.data.models.forEach((item, index) => {
                    item.key = index.toString()
                })
                this.setState({
                    list: res.data.models || [],
                    pagination: res.data.paging || {},
                    loading: false,
                })
            })
        })
    }

    /** input 中的搜索*/
    onSearch(value) {
        // console.log(233, this);
        this.setState({
            filter: {
                ...this.state.filter,
                keyWord: value&&value.trim(),
            },
            pagination: {
                ...this.state.pagination,
                pageNum: 1,
            },
        }, () => {
            // console.log(this.state);
            this.getList()
        })

    }

    /** Table onChange 事件*/
    onChange(pagination, filters, sorter, extra) {
        // console.log('params', pagination, filters, sorter, extra);
        let orderByLoadDate = null
        let orderByPreArrivalPortDate = null
        if (sorter.field === "loadDate") {
            if (sorter.order) {
                orderByLoadDate = sorter.order === "ascend" ? '2' : '1' // 升序
            } else { // sorter.order 可为 undefined 即不筛选
                orderByLoadDate = null
            }
        }
        if (sorter.field === "preArrivalPortDate") {
            if (sorter.order) {
                orderByPreArrivalPortDate = sorter.order === "ascend" ? '2' : '1' // 升序
            } else { // sorter.order 可为 undefined 即不筛选
                orderByPreArrivalPortDate = null
            }
        }
        this.setState({
            pagination: {
                ...this.state.pagination,
                pageNum: pagination.current,
                pageSize: pagination.pageSize,
            },
            filter: {
                ...this.state.filter,
                orderByLoadDate: orderByLoadDate,
                orderByPreArrivalPortDate: orderByPreArrivalPortDate,
            }
        }, () => {this.getList()})

    }

    /** 打开物流信息弹窗*/
    openModalLogistics(item) {
        // console.log(item);
        this.setState({
            showModalLogistics: true,
            logisticsData: item.pubOrderTrackVOS || []
        })
    }

    StepItem(item) {
        return (
            <div className="con1-txt fw_400 font_12 mb_20"
                 data-flex="cross:baseline">
                <span className="mr_26">{item.trackTime&&dayjs(item.trackTime).format('YYYY-MM-DD')}</span>
                <span className="mr_14">{item.trackTime&&dayjs(item.trackTime).format('HH:mm')}</span>
                <p className="fw_500 flex1" style={{lineHeight: '18px',}}>{item.trackDesc}</p>
            </div>
        )
    }
    renderLogistics(list=[]){
       list.forEach((item={})=> {
           item.description = this.StepItem(item)
        })
        return list
    }
    render() {
        return (
            <div className="shipment-order customer-screen pt_16">
                <p className='top-title mb_16'>{Lang({id: 'ChuHuoDan', default: '出货单'})}</p>
                <Search placeholder={Lang({id: 'QingShuRuJiGuiDanHaoHuoGuiHao', default: '请输入集柜单号或柜号'})}
                        onSearch={(value) => this.onSearch(value)}
                        className='mb_16'
                        style={{ width: 288 }} />
                <Spin spinning={this.state.loading}>
                    <Table pagination={{defaultPageSize: this.state.pagination.pageSize, showQuickJumper: true, total: this.state.pagination.total, current: this.state.pagination.pageNum || 1, showSizeChanger: true, showTotal: (total) => `Total ${total} items`,}}
                           dataSource={this.state.list}
                           onChange={this.onChange.bind(this)}>
                        <Column title={Lang({id: 'JiGuiDanHao', default: '集柜单号'})} dataIndex="code" key="code" />
                        <Column title={Lang({id: 'HuoGuiXinXi', default: '货柜信息'})} dataIndex="" key=""
                                render={(text, record, index) => (
                                    <Space direction="vertical ">
                                        <div>{Lang({id: 'GuiHao', default: '柜号',})} {record.cabinetNum}</div>
                                        <div className="subhead">
                                            <span className="mr_8">{Lang({id: 'KeHuShu', default: '客户数'})}/{Lang({id: 'DingDanShu', default: '订单数'})}</span>
                                            <span>{record.buyerNumCount}/{record.orderNumCount}</span>
                                        </div>
                                    </Space>
                                )}/>
                        <Column title={Lang({id: 'ShangPinXinXi', default: '商品信息'})} dataIndex="" key=""
                                render={(text, record, index) => (
                                    <Space direction="vertical ">
                                        <div>{record.skuNum}{Lang({id:'Kuan', default:'款'})}</div>
                                        <div className="subhead">{record.quantity}{Lang({id: 'Xiang', default: '箱'})}</div>
                                    </Space>
                                )}/>

                        <Column title={Lang({id: 'ZhuangGuiShiJian', default: '装柜时间'})}
                                sorter={true}
                                sortDirections={['ascend', 'descend']}
                              /*  defaultSortOrder={this.state.filter.orderByLoadDate==='2'?'ascend':'descend'}*/
                                dataIndex="loadDate"
                                key="loadDate"
                                render={(text, record, index) => (
                                    <span>{record.loadDate?dayjs(record.loadDate).format('YYYY-MM-DD'):'-'}</span>
                                )}/>

                        <Column title={Lang({id: 'YuJiDaoGangShiJian', default: '预计到港时间'})}
                                sorter={true}
                                sortDirections={['ascend', 'descend']}
                               /* defaultSortOrder={this.state.filter.orderByPreArrivalPortDate==='2'?'ascend':'descend'}*/
                                dataIndex="preArrivalPortDate"
                                key="preArrivalPortDate"
                                render={(text, record, index) => (
                                    <span>{record.preArrivalPortDate?dayjs(record.preArrivalPortDate).format('YYYY-MM-DD'):'-'}</span>
                                )}/>

                        <Column title={Lang({id: 'CaoZuo', default: '操作'})} dataIndex="name" key="name"
                                render={(text, record) => (
                                    <div data-flex="cross:center">
                                        <Popover content={__getServerLanguage('WuLiuXinXi')}>
                                            <div
                                                onClick={this.openModalLogistics.bind(this, record)}
                                                className="mr_10">
                                                <HoverIcon
                                                    inactiveIcon="icon-wuliuxinxi"
                                                    activeIcon="icon-wuliuxinxi-xuanzhong"></HoverIcon>
                                            </div>

                                        </Popover>

                                        {/*`/shipmentOrder/details?id=${record.id}`*/}
                                        <Popover content={__getServerLanguage('ChaKanXiangQing')}>
                                            <Link className="link" to={{
                                                pathname: '/shipmentOrder/details',
                                                search: `?id=${record.id}`,
                                                state: {id: record.id, code: record.code}
                                            }}>

                                                <HoverIcon
                                                    inactiveIcon="icon-xiangqing"
                                                    activeIcon="icon-xiangqing-1"></HoverIcon>

                                            </Link>
                                        </Popover>

                                    </div>
                                )} />
                    </Table>
                </Spin>

                <Modal open={this.state.showModalLogistics}
                       width="535px"
                       onCancel={
                           () => {
                               this.setState({
                                   showModalLogistics: false,
                               })
                           }
                       }
                       footer={null}>
                    <div>
                        <div className="font-title font_16 mb_24">{__getServerLanguage('WuLiuXinXi')}</div>
                        <div>
                            <Steps progressDot
                                   current={this.state.logisticsData.length-1}
                                   direction="vertical"
                                   items={this.renderLogistics(this.state.logisticsData)}
                                   />
                            {/*<Steps progressDot={(dot, { status, index }) => {*/}
                                {/*// console.log(dot, 'aaa', status, 'dd', index);*/}
                                {/*return <div>*/}
                                        {/*{*/}
                                            {/*(status=='finish'||status=='process') && (*/}
                                                {/*<span className="iconfont font_12 icon-zhengque font-main  mr_14"></span>*/}
                                            {/*)*/}
                                        {/*}*/}
                                        {/*{*/}
                                            {/*status=='wait' && (*/}
                                                {/*<span className="shipment-order-wait"></span>*/}
                                            {/*)*/}
                                        {/*}*/}
                                {/*</div>*/}
                            {/*}}*/}
                                   {/*current={this.state.logisticsData.length-1}*/}
                                   {/*direction="vertical">*/}
                                {/*{this.state.logisticsData.map((item, index) => (*/}
                                    {/*<Step key={index.toString()}*/}
                                          {/*title={this.StepItem(item)} />*/}
                                {/*))}*/}

                            {/*</Steps>*/}
                        </div>

                        <div className="" data-flex="main:right">
                            <Button
                                onClick={
                                    () => {
                                        this.setState({
                                            showModalLogistics: false,
                                        })
                                    }
                                }
                                shape="round"
                                danger style={{    borderRadius: '32px',}}>
                                {__getServerLanguage('QuXiao')}
                            </Button>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default ShipmentOrder
